// Round to the nearest whole number
// In it's own function in case functionality needs to be changed in future
const roundtoWholeNumber = (number) => Math.round(number);

export default roundtoWholeNumber;
